import { FadeUp, SectionHeading } from "../components/motion";

export default function Host() {
  return (
    <section id="host" data-testid="section-host" className="relative overflow-hidden bg-parchment py-24 sm:py-32">
      <div className="mx-auto max-w-5xl px-5 sm:px-8">
        <div className="grid gap-12 sm:grid-cols-[auto,1fr] sm:gap-16">
          <FadeUp>
            <figure className="flex flex-col items-center gap-4" data-testid="host-portrait">
              <img
                src="/derrick-hall.jpg"
                alt="Chaplain Derrick Hall, host of Chaplain at Sea."
                className="h-auto w-52 rounded-2xl border border-gold/40 object-cover shadow-[0_18px_45px_rgba(11,25,44,0.18)] sm:w-60 lg:w-64"
                data-testid="host-photo"
              />
              <figcaption className="font-mono text-[10px] uppercase tracking-[0.3em] text-gold">Chaplain at Sea</figcaption>
            </figure>
          </FadeUp>

          <div>
            <SectionHeading eyebrow="Meet Your Host" titleLines={["Chaplain Derrick Hall"]} tone="light-bg" />
            <FadeUp delay={0.3}>
              <div className="mt-7 h-px w-full max-w-md bg-gold/50" />
            </FadeUp>
            <FadeUp delay={0.35}>
              <div className="mt-7 max-w-2xl space-y-5" data-testid="host-bio">
                <p className="text-base font-light leading-relaxed text-navy/85 sm:text-lg">
                  For more than 25 years, I have served in ministry. I&rsquo;ve seen how chaplains
                  and caregivers give so much of themselves to others. Whether we serve in
                  healthcare, law enforcement, the military, ministry, or another field, we often
                  encourage others to rest and care for their well-being. It can be harder to follow
                  that same advice ourselves.
                </p>
                <p className="text-base font-light leading-relaxed text-navy/85 sm:text-lg">
                  The idea for Chaplain at Sea grew from my own experience. For a long time, I was
                  afraid to be out on the open sea. Over the years, people encouraged me to take a
                  cruise. I eventually sailed on Royal Caribbean&rsquo;s Ovation of the Seas, and
                  later experienced Icon of the Seas. I realized my fear had kept me from a
                  wonderful experience.
                </p>
                <p className="text-base font-light leading-relaxed text-navy/85 sm:text-lg">
                  I found moments to relax on the balcony with a cup of tea, meditate on
                  God&rsquo;s Word, pray, and reflect. That time helped me see how meaningful it
                  could be for other chaplains to have a similar opportunity&mdash;even if
                  it&rsquo;s their first cruise.
                </p>
                <p className="text-base font-light leading-relaxed text-navy/85 sm:text-lg">
                  Before we go aboard, I hope to share practical guidance to help first-time
                  cruisers know what to expect and feel more prepared for life at sea. At the heart
                  of the retreat, though, is fellowship: a chance to encourage one another, build
                  new friendships, and find space for rest and renewal.
                </p>
                <p className="text-base font-light leading-relaxed text-navy/85 sm:text-lg">
                  Caring for ourselves isn&rsquo;t selfish. When we make room for our own
                  well-being, we can return to our patients, families, colleagues, and communities
                  with renewed energy and care. I hope Chaplain at Sea gives us a chance to practice
                  what we encourage others to do&mdash;and perhaps return with a fresh idea, a new
                  friendship, or even inspiration to write a book of our own.
                </p>
              </div>
            </FadeUp>
          </div>
        </div>
      </div>
    </section>
  );
}
